import { render, staticRenderFns } from "./SetPasswordView.vue?vue&type=template&id=5655a733&scoped=true&"
import script from "./SetPasswordView.vue?vue&type=script&lang=js&"
export * from "./SetPasswordView.vue?vue&type=script&lang=js&"
import style0 from "./SetPasswordView.vue?vue&type=style&index=0&id=5655a733&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5655a733",
  null
  
)

export default component.exports